import React, { Component } from "react";

import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Checkbox } from "primereact/checkbox";
import { Toast } from "primereact/toast";
import "./formulaire.scss";
import "./formulaire-mobile.scss";

import { Button } from "primereact/button";
import { Navigate as Redirect } from "react-router-dom";

export class FormulaireProposition extends Component {
  /* Focus on content for keyboard scrolling */
  boxContent = React.createRef();
  componentDidMount() {
    this.boxContent.current.focus();
    this.props.page(4)
  }

  constructor(props) {
    super(props);
    this.state = {
      fields: {
        telephone: "",
        mail: "",
        complementary: "",
        source: "greenit",
        rgpd: false,
      },
      errors: {
        telephone: false,
        mail: false,
        complementary: false,
      },
      redirect: false,
    };

    this.onRgpdChange = this.onRgpdChange.bind(this);
    this.handleChangeEvent = this.handleChangeEvent.bind(this);
    this.onformsubmit = this.onformsubmit.bind(this);
    this.showSuccess = this.showSuccess.bind(this);
    this.showError = this.showError.bind(this);
  }

  /** Clear timout. */
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  /** Success toast. */
  showSuccess() {
    this.toastSuccess.show({
      severity: "success",
      summary: "Succes",
      detail: "Nous avons enregistré vos détails.",
      life: 1250,
    });
  }

  /** Error toast. */
  showError() {
    this.toastError.show({
      severity: "error",
      summary: "Erreur",
      detail:
        "Une erreur est survenue lors de l'enregistrement de vos détails.",
      life: 1250,
    });
  }

  /** Form submission. */
  onformsubmit = (e) => {
    e.preventDefault();

    let formValid = !Object.values(this.state.errors).some((e) => e === true);

    if (formValid) {
      var details = {
        "email": this.state.fields.mail,
        "phoneNumber": this.state.fields.telephone,
        "info-sup": this.state.fields.complementary,
        source: this.state.fields.source
      };

      var formBody = [];

      for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
      }

      formBody = formBody.join("&");

      fetch(window.env.API_URL + "/formulaire", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: formBody,
      })
        .then((response) => {
          if (response.status === 200) {
            this.showSuccess();
            this.timeout = setTimeout(
              () => this.setState({ redirect: true }),
              1500
            );
          } else {
            this.showError();
          }
        })
        .catch((e) => {
          console.log(e);
          this.showError();
        });
    }
  };

  /** Rgpd checkbox validation. */
  onRgpdChange = (e) => {
    let fieldsCopy = this.state.fields;
    fieldsCopy.rgpd = e.target.checked;
    this.setState({ fields: fieldsCopy });
  };

  /** Error validation. */
  hasErrors(target) {
    let telephonePattern = /^\d{10,13}$/;
    let mailPattern = /^\S+@\S+\.\S{2,}$/;
    let complementaryPattern = /^.{3,}$/;

    switch (target.name) {
      case "telephone":
        if (telephonePattern.test(target.value)) {
          return false;
        } else {
          return true;
        }

      case "mail":
        if (mailPattern.test(target.value)) {
          return false;
        } else {
          return true;
        }

      case "complementary":
        if (complementaryPattern.test(target.value)) {
          return false;
        } else {
          return true;
        }
      default:
        return true;
    }
  }

  /** On change event processing. */
  handleChangeEvent = (e) => {
    let fieldName = e.target.name;

    let fieldsCopy = this.state.fields;
    let errorsCopy = this.state.errors;

    // Set field value.
    fieldsCopy[fieldName] = e.target.value;
    this.setState({ fields: fieldsCopy });

    // Perform error check.
    errorsCopy[fieldName] = this.hasErrors(e.target);
    this.setState({ errors: errorsCopy });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/merci" />;
    } else {
      return (
          <div className="box-content" ref={this.boxContent} tabIndex="-1">
            {/* Title */}
            <div className="d-flex title-bloc">
              <span className="d-flex large-font large-text small-height">
                Nous vous proposons
              </span>
              <span
                className="d-flex large-font large-text small-height"
                style={{ flexFlow: "row wrap", justifyContent: "center" }}
              >
                <span>de vous rencontrer&nbsp;</span>
                <span>pour partager nos</span>
              </span>
              <div
                className="d-flex large-font"
                style={{
                  marginTop: "5px",
                  flexFlow: "row wrap",
                  width: "80%",
                  justifyContent: "center",
                }}
              >
                <span className="d-flex large-font p-tag p-tag-rounded large-text-tag">
                  approches réciproques
                </span>
                <span className="large-text">&nbsp;du Green IT</span>
              </div>
            </div>
            {/* Form */}
            <form onSubmit={this.onformsubmit}>
              <div className="p-fluid p-formgrid first-input-group p-formgroup-inline">
                <div className="input-telephone">
                  <span className="p-float-label">
                    <InputText
                      required={true}
                      type="tel"
                      name="telephone"
                      id="telephone"
                      value={this.state.fields.telephone}
                      onChange={this.handleChangeEvent}
                    />
                    <label htmlFor="telephone">Téléphone*</label>
                  </span>
                  <span className="error">
                    {this.state.errors.telephone
                      ? "Doit être un numéro de téléphone valide."
                      : ""}
                  </span>
                </div>

                <div className="input-mail">
                  <span className="p-float-label">
                    <InputText
                      required={true}
                      id="mail"
                      name="mail"
                      value={this.state.fields.mail}
                      onChange={this.handleChangeEvent}
                    />
                    <label htmlFor="mail">Mail*</label>
                    <span className="error">
                      {this.state.errors.mail
                        ? "Doit être un email valide."
                        : ""}
                    </span>
                  </span>
                </div>
              </div>

              <div className="p-field p-fluid p-formgrid p-grid input-group">
                <span className="p-field p-float-label p-fluid input-group">
                  <InputTextarea
                    required={true}
                    id="complementary"
                    name="complementary"
                    rows={5}
                    cols={30}
                    value={this.state.fields.complementary}
                    onChange={this.handleChangeEvent}
                    autoResize
                  />
                  <label htmlFor="complementary">
                    Informations complémentaires*
                  </label>
                  <span className="error">
                    {this.state.errors.complementary
                      ? "Doit contenir au moins trois caractères."
                      : ""}
                  </span>
                </span>
              </div>

              <div className="p-field-checkbox input-rgpd">
                <Checkbox
                  required={true}
                  inputId="rgpd"
                  name="rgpd"
                  checked={this.state.fields.rgpd}
                  onChange={this.onRgpdChange}
                />
                <label htmlFor="rgpd">
                  En soumettant ce formulaire vous acceptez que vos données
                  personnelles soient utilisées par les équipes commerciales de
                  CREATIVE CORE BUSINESS et de ses filiales dans le cadre de
                  campagnes de communication. Vos données seront conservées 2
                  ans. Conformément à la réglementation sur les données
                  personnelles, vous pouvez exercer vos droits de consultation,
                  rectification, portabilité et de suppression en vous adressant
                  à dpo@groupe-creative.fr
                </label>
              </div>

              <Button
                label="Envoyer"
                icon="pi pi-arrow-right"
                iconPos="right"
                type="submit"
                className="p-button-rounded p-button-raised ui-button large-icon-button"
                style={{ margin: "45px 0" }}
              ></Button>
            </form>
            <Toast ref={(el) => (this.toastSuccess = el)} />
            <Toast ref={(el) => (this.toastError = el)} />
          </div>
      );
    }
  }
}